import { api } from "@/plugins/api";

const state = {
  actions: [],
};

const getters = {
  getAllActions: (state) => state.actions,

  getActionById: (state) => (id) =>
    state.actions.filter((action) => action.id === id),
};

const actions = {
  async fetchAllActions({ commit }, customer_id) {
    //console.log("customer_id:", customer_id);
    try {
      const response = await api.get(`/actions?customer_id=${customer_id}`);
      const actions = response.data.data;
      commit("setActions", actions);
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async fetchCustomerActions({ commit }, customer_id) {
    try {
      const response = await api.get(`/actions/${customer_id}`);
      const actions = response.data.data;
      commit("setActions", actions);
      return true;
    } catch (error) {
      return false;
    }
  },
  async promptCustomer({ commit }, id) {
    try {
      const response = await api.post(`/actions/prompt/${id}`);
      //console.log("pppppp:", response.data.data);
      commit("addPrompt", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async promptAllCustomers() {
    try {
      // const response = await api.post(`/actions/prompt`);
      await api.post(`/actions/prompt`);
      //console.log("response", response);
      return true;
    } catch (error) {
      return false;
    }
  },
  async promptAllCustomersBySector(context, sector_id) {
    //console.log("sector", sector_id);
    try {
      //const response = await api.post(`/actions/prompt_all/${sector_id}`);
      await api.post(`/actions/prompt_all/${sector_id}`);
      //console.log("response", response);
      return true;
    } catch (error) {
      return false;
    }
  },
  async addPayment({ commit }, data) {
    try {
      const response = await api.post(`/actions/payment/${data.customer_id}`, {
        value: data.payment,
        toFeed: data.toFeed,
      });

      commit("addPayment", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async addFix({ commit }, data) {
    try {
      const response = await api.post(`/actions/fix/${data.customer_id}`, {
        value: data.payment,
        toFeed: data.toFeed,
      });
      commit("addFix", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async deleteAction({ commit }, id) {
    try {
      const response = await api.delete(`/actions/${id}`);
      //console.log("response", response);
      if (response) {
        commit("removeAction", id);
      }
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setActions(state, actions) {
    state.actions = actions;
    //console.log("mu", state.actions);
  },
  addPrompt(state, prompt) {
    //console.log("new prompts:", prompt);
    // state.actions.unshift(prompt);
    for (var pp of prompt) {
      pp.actionDate = new Date(pp.actionDate).toLocaleString();
      state.actions.unshift(pp);
    }
  },

  addPrompts(state, prompts) {
    //console.log("new prompts:", prompts);
    for (var pp of prompts) {
      pp.actionDate = new Date(pp.actionDate).toLocaleString();
      state.actions.unshift(pp);
    }
  },
  addPayment(state, payment) {
    //console.log("payment:", payment);
    payment.actionDate = new Date(payment.actionDate).toLocaleString();
    state.actions.unshift(payment);
  },
  addFix(state, fix) {
    fix.actionDate = new Date(fix.actionDate).toLocaleString();
    state.actions.unshift(fix);
  },
  removeAction(state, id) {
    const index = state.actions.findIndex((action) => action.id == id);
    if (index !== -1) {
      state.actions.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
